import { api } from "@/lib/api";

export type WaStatus =
  | "pending" | "sending" | "sent" | "delivered" | "read" | "failed" | "received";

export interface WaMessage {
  id: string;
  direction: "inbound" | "outbound";
  phone_number: string;
  body: string;
  status: WaStatus;
  template_id: string | null;
  ticket_id: string | null;
  sent_at: string | null;
  delivered_at: string | null;
  read_at: string | null;
  created_at: string;
}

export interface WindowStatus {
  in_window: boolean;
  minutes_left: number;
}

export interface TicketWhatsapp {
  window: WindowStatus;
  messages: WaMessage[];
}

export interface WaTemplate {
  id: string;
  name: string;
  language: string;
  category: "utility" | "marketing" | "authentication";
  body: string;
  variables: string[] | null;
  status: "approved" | "pending" | "rejected";
  created_at: string;
}

export interface WaTemplateBody {
  name: string;
  language?: string;
  category?: string;
  body: string;
  variables?: string[] | null;
  status?: string;
}

export interface SendBody {
  to_number: string;
  ticket_id?: string | null;
  template_name?: string | null;
  language?: string;
  variables?: Record<string, string> | null;
  text?: string | null;
}

export const ticketWhatsapp = (ticketId: string) =>
  api.get<TicketWhatsapp>(`/tickets/${ticketId}/whatsapp`);
export const sendWhatsapp = (body: SendBody) => api.post<WaMessage>("/whatsapp/send", body);

export const listTemplates = () => api.get<WaTemplate[]>("/whatsapp/templates");
export const createTemplate = (body: WaTemplateBody) =>
  api.post<WaTemplate>("/whatsapp/templates", body);
export const updateTemplate = (id: string, body: Partial<WaTemplateBody>) =>
  api.patch<WaTemplate>(`/whatsapp/templates/${id}`, body);
export const deleteTemplate = (id: string) =>
  api.delete<{ message: string }>(`/whatsapp/templates/${id}`);
